import React from 'react';
// import {
//   getHeroContent, HeroImage, StoreLogo, SearchBar, TopControls, CartBtn, EmptyState, BusinessDetails, TabContent, StoreFooter, getAddress, getBtnRadius, adjustColor, AWS_URL, ProductList, ServiceList, FaHeart, FaWhatsapp, MdSearch, MdShoppingCart, MdFilterList, MdStore, MdList, MdLocalPhone, MdHistory, MdExitToApp, MdAccountCircle, MdLogin, MdHome, MdMenu, getTabLabel, isDarkTheme, InlineEditableText, THEME_IMAGES
// } from './ThemeLayoutHelpers';
import SenseLayout from './SenseLayout';

export default function EditorialLayout({ p }) {
  return <SenseLayout p={p} />;
}